import React from 'react';
import PropTypes from 'prop-types';

import {Field, Form, Formik} from 'formik';

import CredentialsFormValidationSchema from './CredentialsFormValidationSchema';

// import { NavLink } from 'react-router-dom';
// import { IconArrowLeft16 } from 'pac-ux-components';
import SubmitFormGroup from 'components/SubmitFormGroup';

import {DisplayFormikState} from 'components/DisplayFormikState';

import {I18n} from '@aws-amplify/core';

import {Box, SimpleGrid} from '@mantine/core';

import {PacFormikInput, PacFormikPasswordInput,} from 'pac-platform-ui-components';

const FormComponent = ({ values, handleSubmit, isSubmitting }) => {
    return (
        <React.Fragment>
            <Form onSubmit={handleSubmit}>
                <SimpleGrid>
                    <Box mt="sm">
                        <Field
                            type="email"
                            name="email"
                            value={values.email}
                            placeholder={I18n.get('Email')}
                            component={PacFormikInput}
                            disabled={false}
                        />
                    </Box>

                    <Box>
                        <Field
                            autoFocus
                            tabIndex={1}
                            name="password"
                            placeholder={I18n.get('Password')}
                            component={PacFormikPasswordInput}
                        />
                    </Box>

                    <SubmitFormGroup
                        cancelUrl="/"
                        disabled={isSubmitting}
                        submitButtonLabel={I18n.get('Next')}
                    />
                </SimpleGrid>
            </Form>

            {false && <DisplayFormikState {...values} />}
        </React.Fragment>
    );
};

const CredentialsForm = ({ emailAddress, handleSubmit }) => {
    let initialValues = {
        email: emailAddress ? emailAddress : '',
        password: '',
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={CredentialsFormValidationSchema}
            onSubmit={handleSubmit}
        >
            {(props) => <FormComponent {...props} />}
        </Formik>
    );
};

export default CredentialsForm;

FormComponent.propTypes = {
    values: PropTypes.object,
    handleSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
    handleChange: PropTypes.func,
};

CredentialsForm.propTypes = {
    handleSubmit: PropTypes.func,
    emailAddress: PropTypes.string,
};
